module.exports = __webpack_public_path__ + "static/media/87d13d49.jpg";